import { Reveal } from "@/components/pause/motion";
import { scrollToId } from "@/lib/smooth";

const activities = [
  "Silent Mornings",
  "Forest Walks",
  "Breathwork",
  "Sattvic Meals",
  "Yoga Nidra",
  "Vedic Chanting",
];

export const Retreat = () => {
  return (
    <section id="retreats" data-testid="retreat-section" className="bg-[#3B5A3A] text-[#FAF7F2] py-28 md:py-40">
      <div className="mx-auto max-w-[1100px] px-5 md:px-10 text-center">
        <Reveal>
          <img src="/images/logo.png" alt="Pause." data-testid="retreat-logo" className="h-20 w-20 object-contain mx-auto mb-8" />
          <p className="font-body text-xs uppercase tracking-[0.28em] text-[#F5C800] mb-8">Off-grid Retreats</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-light text-6xl md:text-8xl leading-[0.92] tracking-tight">
            Disconnect <span className="italic">to</span> <br className="hidden md:block" />
            Reconnect<span className="text-[#F5C800]">.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-xl mx-auto font-body text-base md:text-lg text-[#FAF7F2]/75 leading-relaxed">
            A few days, no signal, and a small circle of people. Wake with the birds, move with the light,
            and remember what unhurried feels like.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {activities.map((a) => (
              <span
                key={a}
                className="font-body text-[13px] px-4 py-2 rounded-full border border-[#FAF7F2]/30 text-[#FAF7F2]/85 hover:border-[#F5C800] hover:text-[#F5C800] transition-colors duration-300"
              >
                {a}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <button
            data-testid="retreat-cta"
            onClick={() => scrollToId("#waitlist")}
            className="mt-12 font-body text-sm uppercase tracking-[0.12em] font-medium bg-[#F5C800] text-[#1A1A1A] px-8 py-4 rounded-full hover:scale-[1.04] hover:shadow-[0_12px_40px_rgba(245,200,0,0.3)] transition-transform duration-300"
          >
            Request Retreat Dates
          </button>
        </Reveal>
      </div>
    </section>
  );
};
